import { Pipe, PipeTransform } from '@angular/core';
import { Employee } from 'src/app/shared/models/employee/employee';

@Pipe({
	name: 'filterEmployeeByAllFields'
})
export class FilterEmployeeByAllFieldsPipe implements PipeTransform {
	transform(employees: Employee[], filter: string): Employee[] {
		if (
			!employees ||
			employees === null ||
			(Array.isArray(employees) && employees.length === 0) ||
			!filter ||
			filter === null ||
			filter === ''
		) {
			return employees;
		}

		filter = filter.toLowerCase();

		return employees.filter((employee) => {
			const employeeName = employee?.firstName + ' ' + employee?.lastName;
			const careSkills = employee.careSkills || [];

			// Vérifie les compétences de soins
			const careSkillMatch = careSkills.some((careSkill) =>
				careSkill.name?.toLowerCase().includes(filter)
			);

			return (
				employeeName?.toLowerCase().includes(filter) ||
				employee.email?.toLowerCase().includes(filter) ||
				careSkillMatch ||
				employee.specialties?.some((spe) =>
					spe.name.toLowerCase().includes(filter)
				)
			);
		});
	}
}
